// ...existing code...
import React, { useEffect, useRef } from "react";

function Drawer({ open, onClose, image, title = "", name = "", qualifications = "", bio = "" }) {
    const asideRef = useRef(null);
    useEffect(() => {
        // prevent background scroll while drawer open
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);
    const isSmallScreen = typeof window !== "undefined" && window.innerWidth < 768;


    return (



        <div
            aria-hidden={!open}
            style={{ position: "fixed", inset: 0, zIndex: 9998, pointerEvents: open ? "auto" : "none" }}
        >
            {/* burgundy tinted backdrop (covers entire page) */}
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(77, 30, 28,0.75)",
                    transition: "opacity 300ms ease",
                    opacity: open ? 1 : 0,
                    zIndex: 9998,
                }}
            />

            {/* panel: half-screen width on desktop, scrollable content, opaque background and higher z-index */}
            <aside
                ref={asideRef}
                role="dialog"
                aria-modal="true"
                style={{
                    position: "fixed",
                    right: 0,
                    top: 0,
                    height: "100vh",
                    width: isSmallScreen ? "95vw" : "50vw",
                    maxWidth: 800,
                    minWidth: 320,
                    backgroundColor: "rgba(255,255,255,0.98)",
                    zIndex: 9999,
                    transform: open ? "translateX(0)" : "translateX(100%)",
                    transition: "transform 320ms cubic-bezier(.2,.9,.3,1)",
                    willChange: "transform",
                    overflow: "hidden",
                }}
            >
                <div className="flex items-center justify-between p-4 border-b">
                    <h3 className="text-lg font-semibold text-warmGray-800">{title || "Image"}</h3>
                    <button onClick={onClose} className="text-warmGray-600 hover:text-warmGray-800 px-2 py-1">
                        <i className="fas fa-times text-2xl"></i>
                    </button>
                </div>

                {/* content area scrolls independently, image constrained to viewport height */}
                <div style={{ height: "calc(100vh - 64px)", overflowY: "auto", padding: "1rem" }}>

                    {/* optional extra content below image will scroll */}
                    <div className="w-full lg:w-10/12  px-2 mr-auto ml-auto">
                        <div className="relative flex flex-col lg:flex-row min-w-0 break-words p-2  bg-white w-full mb-6 shadow-lg rounded-lg">
                            <div className="relative flex flex-col lg:w-3/12">

                                {image ? (
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

                                        <img
                                            alt={title || "drawer image"}
                                            src={typeof image === "string" ? image : image}
                                            className="mx-auto rounded-lg"
                                            style={{ width: "100%", maxHeight: "60vh", objectFit: "contain" }}
                                        />
                                    </div>

                                ) : (
                                    <div className="text-warmGray-600">No image</div>
                                )}

                            </div>
                            <div className="flex flex-col lg:w-9/12 justify-center p-4 ">
                                <h4 className="text-xl font-bold text-warmGray-900 pb-2">
                                    {name}
                                </h4>
                                <h5 className="text-md font-semibold text-warmGray-900 pb-4">
                                    {qualifications}
                                </h5>


                                <div className="text-md font-light  whitespace-pre-line" style={{ lineHeight: '1.6' }}>

                                    <p className="text-md text-warmGray-900 mb-2">
                                        {bio}</p>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </aside>
        </div>
    );
}


export default Drawer;